export default "__VITE_ASSET__b_uvq_JV__"